"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadError = void 0;
exports.doValidateImageDimensions = doValidateImageDimensions;
exports.validateBackgroundFileSize = validateBackgroundFileSize;
exports.validateBackgroundUpload = validateBackgroundUpload;
exports.validateImageFileType = validateImageFileType;
exports.validateUploadedFilesCount = validateUploadedFilesCount;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _sourceFileHelper = require("../sourceFileHelper");
var _constants = require("@studio/constants");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var UploadError = exports.UploadError = /*#__PURE__*/function (_Error) {
  (0, _inherits2["default"])(UploadError, _Error);
  var _super = _createSuper(UploadError);
  function UploadError() {
    var _this;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Upload Error';
    (0, _classCallCheck2["default"])(this, UploadError);
    _this = _super.call(this, message);
    _this.name = 'UploadError';
    return _this;
  }
  return (0, _createClass2["default"])(UploadError);
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
function validateBackgroundUpload(_x, _x2) {
  return _validateBackgroundUpload.apply(this, arguments);
}
function _validateBackgroundUpload() {
  _validateBackgroundUpload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file, fileCount) {
    var errors;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          errors = [];
          try {
            validateImageFileType(file);
          } catch (e) {
            errors.push(e.message);
          }
          try {
            validateBackgroundFileSize(file);
          } catch (e) {
            errors.push(e.message);
          }
          _context.prev = 3;
          _context.next = 6;
          return doValidateImageDimensions(file);
        case 6:
          _context.next = 11;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](3);
          errors.push(_context.t0.message);
        case 11:
          try {
            validateUploadedFilesCount(fileCount);
          } catch (e) {
            errors.push(e.message);
          }
          return _context.abrupt("return", errors);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 8]]);
  }));
  return _validateBackgroundUpload.apply(this, arguments);
}
function doValidateImageDimensions(_x3) {
  return _doValidateImageDimensions.apply(this, arguments);
}
function _doValidateImageDimensions() {
  _doValidateImageDimensions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(file) {
    var isDimensionValid;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _sourceFileHelper.validateImageDimensions)(file);
        case 2:
          isDimensionValid = _context2.sent;
          if (isDimensionValid) {
            _context2.next = 5;
            break;
          }
          throw new UploadError("File can't be larger than [1920 x 1080] pixels");
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _doValidateImageDimensions.apply(this, arguments);
}
function validateImageFileType(file) {
  var fileName = file.name;
  var isImageFile = (0, _sourceFileHelper.getFileSourceType)(fileName) === _constants.IMAGE_FILE;
  if (!isImageFile) {
    throw new UploadError('File type is not supported');
  }
}
function validateBackgroundFileSize(file) {
  if (+file.size > _constants.MAX_IMAGE_SIZE_IN_BYTES) {
    throw new UploadError("File can't be larger than 5MB");
  }
}
function validateUploadedFilesCount(fileCount) {
  if (fileCount > 1) {
    throw new UploadError('Exceeds maximum number of uploads (limit is 1)');
  }
}